module.exports = __webpack_public_path__ + "static/media/networking.5abb7ba7.jpg";